export const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" }
];